import React, { useContext, useState } from "react";
import "./styles.css";
import { StoreContext } from "../../../Library/contexts";
import { DEV_TYPE_VALUES, DEVICE_TYPES, SELLER_DES } from "../../../Library/constants";
import { ShrinkArrowLeft } from "../../../Assets/images/svgs";
import { IconButton } from "@chakra-ui/react";

const WalletCount = ({ label, count, isWalletExpanded }) => (
  <div className={`dev-type-count ${isWalletExpanded ? "unset-position" : ""}`}>
    <p className="header-wallet-label">{label}: <span>{count || 0}</span></p>
  </div>
);

const HeaderWallet = () => {
  const { devStock } = useContext(StoreContext);
  const DESIGNATION = JSON.parse(window.localStorage.getItem("des"));
  const [isWalletExpanded, setIsWalletExpanded] = useState(true);

  if (DESIGNATION !== SELLER_DES) return null;

  const walletCount = devStock.count || 0;
  const batWiseCount = devStock.batWiseCount || {};

  return (
    <div className="header-wallet">
      <div className="wallet-total">
        <p className="header-wallet-label">Devices In Stock: <span>{walletCount}</span></p>
      </div>

      {DEVICE_TYPES.map(({ label }, idx) => {
        const count = batWiseCount[DEV_TYPE_VALUES[label]];
        const isNotLastItem = idx !== DEVICE_TYPES.length - 1;

        return (
          <React.Fragment key={label}>
            <WalletCount label={label} count={count} isWalletExpanded={isWalletExpanded} />
            {isWalletExpanded && isNotLastItem && <div className="dev-type-seperator"></div>}
          </React.Fragment>
        );
      })}
      <IconButton icon={<ShrinkArrowLeft />} variant="ghost" rounded="full" onClick={() => setIsWalletExpanded(!isWalletExpanded)} className={`shrink-icon-button ${!isWalletExpanded ? "rotate-icon" : ""}`} />
    </div>
  );
};

export default HeaderWallet;
